__turbopack_context__.v({
  "fade-in": "FavoritesLink-module-scss-module__R_9FyW__fade-in",
  "favorite-enter": "FavoritesLink-module-scss-module__R_9FyW__favorite-enter",
  "favorite-exit": "FavoritesLink-module-scss-module__R_9FyW__favorite-exit",
  "favoritesLink": "FavoritesLink-module-scss-module__R_9FyW__favoritesLink",
  "isLanding": "FavoritesLink-module-scss-module__R_9FyW__isLanding",
  "isVisible": "FavoritesLink-module-scss-module__R_9FyW__isVisible",
});
